/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import $ from 'jquery'
import { FormControl, FormHelperText, Grid, MenuItem, Select, Typography } from '@mui/material'

import { variantTypes } from '../../../../../../constants'
import { cacheUpdateFlowGroupTaskAssign } from '../../../../../../actions'
import { Logger, LoggerTypes } from '../../../../../../utils'
import { FlowElementBottomButtons } from '../../../FlowElementBottomButtons'
import '../../../common-elements-style.scss'
import './style.scss'

const NONE_VALUE = 'NONE'

const defaultValue = {
  assign_to_task_id: NONE_VALUE
}

export const FlowElementTaskAssignPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentTaskInstance,
  onSaveAssignTask,
  tasks,
  errors
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const params = useParams()

  const availableAssignableTasks = (tasks && tasks.filter((el) => el.id !== currentTaskInstance?.task?.id)) || null

  const assign_to_task_idValue =
    `${currentTaskInstance.assign_to_task_id ? currentTaskInstance.assign_to_task_id : NONE_VALUE}` ||
    defaultValue.assign_to_task_id

  const [assign_to_task_id, setAssignToTaskId] = useState(assign_to_task_idValue)
  const [assign_to_task_object, setAssignToTaskObject] = useState(null)

  const pid = params.pid || currentProject.id || null
  const sid = params.sid || currentScenario.id || null
  const fid = params.fid || (currentFlowGroup && currentFlowGroup.id) || null

  const errorOverClassName = '__elementErrorOver'

  useEffect(() => {
    setAssignToTaskId(assign_to_task_idValue)
  }, [currentTaskInstance])

  const onChangeAssignToTaskObject = (e) => {
    e.stopPropagation()
    const _id = e.target.value
    const newTask = tasks.find((el) => el.id === _id)

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAssignPanel.onChangeAssignToTaskObject()', {
      e,
      availableAssignableTasks,
      _id,
      tasks,
      newTask
    })
    setAssignToTaskId(_id)
    setAssignToTaskObject(newTask)
  }

  // --

  const onClickSave = (e) => {
    e.stopPropagation()

    const assign_task_id = assign_to_task_id === '' ? null : assign_to_task_id

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskAssignPanel.onClickSave()', {
      assign_task_id,
      assign_to_task_object
    })

    onSaveAssignTask(assign_task_id, (res) => {
      Logger.trace(
        LoggerTypes.CONTROLLER,
        'FlowElementTaskAssignPanel.onClickSave().cacheUpdateFlowGroupTaskAssign()',
        { res, pid, sid, fid }
      )

      dispatch(cacheUpdateFlowGroupTaskAssign(currentFlowGroup, res.data))
    })
  }

  const onTaskInstanceOver = (e, element) => {
    e.preventDefault()
    e.stopPropagation()

    element?.instances &&
      element.instances.forEach((el) => {
        const _el = $(`[data-element-id="${el?.element_id}"]`)
        const _elLabel = $(`[data-element-id="${el?.element_id}_label"]`)

        // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onTaskInstanceOver()', { element_id: el.element_id })

        if (_el) {
          _el.addClass(errorOverClassName)
          if (_elLabel) {
            _elLabel.addClass(errorOverClassName)
          }
        }
      })
  }

  const onTaskInstanceOut = (e, element) => {
    e.preventDefault()
    e.stopPropagation()

    element?.instances &&
      element.instances.forEach((el) => {
        const _el = $(`[data-element-id="${el?.element_id}"]`)
        const _elLabel = $(`[data-element-id="${el?.element_id}_label"]`)

        // Logger.trace(LoggerTypes.CONTROLLER, 'FlowTaskCard.onTaskInstanceOut()', { element_id: el.element_id })

        if (_el) {
          _el.removeClass(errorOverClassName)
          if (_elLabel) {
            _elLabel.removeClass(errorOverClassName)
          }
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskAssignPanel.render()', {
    currentProject,
    currentScenario,
    currentFlowGroup,
    currentTaskInstance,
    task_assign: {
      assign_to_task_id,
      availableAssignableTasks,
      assign_to_task_object
    },
    tasks,
    errors
  })

  return (
    <div className="FlowElementTaskAssignPanel">
      <form>
        <Grid container spacing={2} style={{ padding: '10px' }}>
          {/*  assign_to_task_id  */}
          {availableAssignableTasks && availableAssignableTasks.length > 0 ? (
            <Grid item xs={12} sm={12} className="common_fullwidth">
              <p className="explanation">{t('flowActions.tasks.panels.task_assign.explanation')}</p>
              <hr />
              <Typography style={{ height: '25px' }}>
                {t('flowActions.tasks.panels.task_assign.assign_to_task_id.label')}
              </Typography>
              <FormControl error={Boolean(errors && errors?.task_id)} className="common_fullwidth">
                <Select
                  className="common_fullwidth"
                  value={assign_to_task_id || NONE_VALUE}
                  onChange={onChangeAssignToTaskObject}
                  variant={variantTypes.OUTLINED}
                >
                  <MenuItem value={NONE_VALUE}>
                    {t('flowActions.tasks.panels.task_assign.assign_to_task_id.default')}
                  </MenuItem>
                  {availableAssignableTasks.map((el, index) => (
                    <MenuItem
                      key={`taskAssigned-${index}`}
                      value={el.id}
                      onMouseOver={(e) => onTaskInstanceOver(e, el)}
                      onMouseOut={(e) => onTaskInstanceOut(e, el)}
                    >
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{(errors && errors?.task_id) || ''}</FormHelperText>
              </FormControl>
            </Grid>
          ) : (
            <Typography className="explanation" style={{ padding: '11px 0 0 15px' }}>
              {t('flowActions.tasks.panels.task_assign.no_assignable_tasks_found')}
            </Typography>
          )}
        </Grid>

        <FlowElementBottomButtons onSave={onClickSave} />
      </form>
    </div>
  )
}

FlowElementTaskAssignPanel.displayName = 'FlowElementTaskAssignPanel'

FlowElementTaskAssignPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentTaskInstance: PropTypes.object,
  tasks: PropTypes.arrayOf(PropTypes.object),
  onSaveAssignTask: PropTypes.func.isRequired,
  errors: PropTypes.array
}

FlowElementTaskAssignPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentTaskInstance: null,
  tasks: [],
  onSaveAssignTask: () => {},
  errors: null
}
